import { useQuery } from "@apollo/client/react";
import { GetAllPlannedBreaks } from "hooks/apollo/plannedBreak/plannedBreak.gql";

export default function useGetPlannedBreaks() {
  const { data, loading, error } = useQuery(GetAllPlannedBreaks);

  const plannedBreaks = loading ? null : data.plannedBreaks;

  return { data, error, loading, plannedBreaks };
}
